export const RECEIVE_BUSINESS_TRUSTPASS = "RECEIVE_BUSINESS_TRUSTPASS";

export const UPDATE_BUSINESS_TRUSTPASS_INFO                      = "UPDATE_BUSINESS_TRUSTPASS_INFO";
export const UPLOAD_BUSINESS_TRUSTPASS_PROOF_OF_BILLING          = "UPLOAD_BUSINESS_TRUSTPASS_PROOF_OF_BILLING";
export const UPLOAD_BUSINESS_TRUSTPASS_BIR                       = "UPLOAD_BUSINESS_TRUSTPASS_BIR";
export const UPLOAD_BUSINESS_TRUSTPASS_GIS                       = "UPLOAD_BUSINESS_TRUSTPASS_GIS";
export const UPLOAD_BUSINESS_TRUSTPASS_OWNERSHIP                 = "UPLOAD_BUSINESS_TRUSTPASS_OWNERSHIP";
export const UPLOAD_BUSINESS_TRUSTPASS_ARTICLES_OF_PARTNERSHIP   = "UPLOAD_BUSINESS_TRUSTPASS_ARTICLES_OF_PARTNERSHIP";



// WEBPACK FOOTER //
// ./src/features/trustpass/businessTrustpassActionTypes.js